<template>
  <div class="user-review">
    <desktop-user-review
      :review="review" />

    <mobile-user-review
      :review="review" />
  </div>
</template>

<script>
import DesktopUserReview from "@/pages/book/components/desktop-user-review";
import MobileUserReview from "@/pages/book/components/mobile-user-review";

export default {
  name: "UserReview",
  components: {
    DesktopUserReview,
    MobileUserReview
  },
  props: {
    review: {
      type: Object,
      default: () => {}
    }
  }
};
</script>

<style lang="scss">
.user-review {

  &__avatar {
    @include font-style(h2, $color: $white, $weight: normal);

    display: flex;
    justify-content: center;
    align-items: center;

    width: spacing(56px);
    height: spacing(56px);

    text-transform: capitalize;

    background-color: $blue;

    border-radius: 50%;
  }
}
</style>
